// Maps a generated draft onto a meeting's sections (spec §3.3). Pure — useGenerate.js performs
// the writes. "replace" overwrites targets the user confirmed; "fillEmpty" only fills sections
// with no items (and an empty headline).
export const DRAFT_TARGETS = [
  { key: "agenda", kind: "agenda", title: "Agenda" },
  { key: "tasksCompleted", title: "Tasks completed" },
  { key: "proposalStatus", title: "Proposal status" },
  { key: "discussionItems", title: "Discussion items" },
  { key: "nextSteps", title: "Next steps" },
];

export function findTarget(meeting, target) {
  const sections = meeting.sections || [];
  if (target.kind === "agenda") return sections.find((s) => s.kind === "agenda") || null;
  return sections.find((s) => s.kind !== "agenda" && (s.title || "").trim().toLowerCase() === target.title.toLowerCase()) || null;
}

export function occupiedTargets(meeting, { only = null } = {}) {
  const out = [];
  if (!only && meeting.summary?.headline) out.push("Headline");
  for (const t of DRAFT_TARGETS) {
    if (only && t.key !== only) continue;
    const s = findTarget(meeting, t);
    if (s && (s.items || []).length) out.push(s.title);
  }
  return out;
}

export function planDraft(meeting, draft, { only = null, mode = "replace" } = {}) {
  const writes = [];
  const skipped = [];
  const sections = draft?.sections;
  for (const t of DRAFT_TARGETS) {
    if (only && t.key !== only) continue;
    if (!sections || !(t.key in sections)) continue; // the model had nothing to say — never overwrite with []
    const items = sections[t.key] || [];
    const s = findTarget(meeting, t);
    if (!s && t.kind === "agenda") { skipped.push("Agenda (this meeting has no agenda section)"); continue; }
    // An empty list is never written: it would wipe hand-written items, "succeed" a Regenerate by
    // emptying the section, or re-add a standard section the user deleted. It's a no-op even for
    // an existing empty section, so the run reports honestly that nothing changed there.
    if (!items.length) { skipped.push(`${s ? s.title : t.title} (nothing new in the data — left as it was)`); continue; }
    if (!s) {
      writes.push({ sectionId: null, title: t.title, rev: 0, items });
      continue;
    }
    if (mode === "fillEmpty" && (s.items || []).length) continue;
    writes.push({ sectionId: s.id, title: s.title, rev: s.rev, items });
  }
  const headline = only || !draft?.headline ? null : mode === "fillEmpty" && meeting.summary?.headline ? null : draft.headline;
  return { writes, headline, skipped };
}
